import React, { useState } from 'react';
import HistoryModal from '../HistoryModal';
import { Study } from '../StudyList';
import { Button, Icon, IconList } from 'components/core';
import { getReviewId } from 'query/review';
import { QueryProvider } from 'query/QueryProvider';

type HistoryButtonProps = {
  study: Study;
  category?: string;
};

export const HistoryButton = ({ study, category }: HistoryButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const reviewId = getReviewId();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        size="sm"
        type="brand"
        variant="ghost"
        onClick={handleOpenModal}
        data-pendo-key="history-button"
      >
        <Icon icon={IconList.light.faClockRotateLeft} />
        History
      </Button>

      {isModalOpen && (
        // Only render the QueryProvider & HistoryModal when the modal is open
        // to avoid unnecessary query client initializations on the old Backbone pages.
        <QueryProvider>
          <HistoryModal
            isOpen={true}
            onClose={handleCloseModal}
            reviewId={reviewId ? parseInt(reviewId) : 0}
            studyId={study.id}
            studyTitle={study.title || '[Untitled reference]'}
            category={category}
          />
        </QueryProvider>
      )}
    </>
  );
};
